// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"748":"d0db4e13","854":"b158abb8"}[chunkId] + ".js";
};